import Heading from '@service-victoria/component-library/components/Text/Heading';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

import { clampLines } from 'utils/style';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: ${colors.orange25};
  padding: 16px 20px;
  box-sizing: border-box;

  @media ${device.isDesktop} {
    padding: 20px 50px;
  }
`;

export const Content = styled.div`
  padding-right: 12px;
`;

export const Action = styled.button`
  border: 0;
  background: transparent;
  width: 36px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const DetailLine = styled(Heading.H3).attrs({
  as: 'span',
  fontWeight: 600
})`
  ${clampLines(2)}

  &:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }
`;
